import {TEST_IDS} from '@github-ui/issue-body/constants/test-ids'
import {ChevronDownIcon, ChevronUpIcon, ProjectTemplateIcon, TableIcon} from '@primer/octicons-react'
import {IconButton, Link, Truncate} from '@primer/react'
import {graphql, useFragment} from 'react-relay'

import {LABELS} from '../../constants/labels'
import type {ProjectItemSectionView$key} from './__generated__/ProjectItemSectionView.graphql'
import {SingleSelectField} from './fields/SingleSelectField'
import styles from './ProjectItemSectionView.module.css'

export type ProjectItemSectionViewProps = {
  projectItem: ProjectItemSectionView$key
  open: boolean
  setOpen: (isOpen: boolean) => void
  onIssueUpdate: () => void
  isProjectOpen: boolean
}

export function ProjectItemSectionView({
  projectItem,
  setOpen,
  open,
  onIssueUpdate,
  isProjectOpen,
}: ProjectItemSectionViewProps) {
  const {id, project, fieldValueByName, isArchived} = useFragment(
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    graphql`
      fragment ProjectItemSectionView on ProjectV2Item {
        id
        isArchived
        project {
          id
          title
          template
          viewerCanUpdate
          url
          field(name: "Status") {
            ...SingleSelectFieldConfigFragment @dangerously_unaliased_fixme
          }
        }
        fieldValueByName(name: "Status") {
          ...SingleSelectFieldFragment @dangerously_unaliased_fixme
        }
      }
    `,
    projectItem,
  )

  return (
    <div className={styles.ProjectItemSectionViewContainer}>
      {isProjectOpen ? (
        <span className={styles.projectTitleText}>
          {project.template ? (
            <ProjectTemplateIcon className="fgColor-muted" aria-hidden="true" />
          ) : (
            <TableIcon className="fgColor-muted" aria-hidden="true" />
          )}
          <span className={styles.truncatedProjectTitle}>{project.title}</span>
        </span>
      ) : (
        <div className={styles.projectLinkContainer}>
          <Link href={project.url} hoverColor={'accent.fg'} tabIndex={0} className={styles.projectLink}>
            {project.template ? (
              <ProjectTemplateIcon className="fgColor-muted" aria-hidden="true" />
            ) : (
              <TableIcon className="fgColor-muted" aria-hidden="true" />
            )}
            <Truncate title={project.title} data-testid={TEST_IDS.projectTitle} className={styles.Truncate}>
              {project.title}
            </Truncate>
          </Link>
        </div>
      )}
      <div className={styles.statusFieldContainer}>
        {project.field && fieldValueByName !== undefined && (
          <SingleSelectField
            viewerCanUpdate={project.viewerCanUpdate && !isArchived}
            itemId={id}
            projectId={project.id}
            field={project.field}
            value={fieldValueByName}
            onIssueUpdate={onIssueUpdate}
            isStatusField
          />
        )}
        <IconButton
          variant="invisible"
          onClick={() => {
            setOpen(!open)
          }}
          size="small"
          icon={!open ? ChevronDownIcon : ChevronUpIcon}
          aria-label={!open ? LABELS.showMoreProjectFields : LABELS.hideMoreProjectFields}
          aria-expanded={open}
        />
      </div>
    </div>
  )
}

try{ ProjectItemSectionView.displayName ||= 'ProjectItemSectionView' } catch {}